import { useCallback, useEffect, useRef } from "react";
import { useUserDataContext } from "../../user_data_context";
import { RESUME_EVENT, takeResume, type ResumeAction } from "./auth_resume";

/** Continues `action` after a Google round trip, once a user is known and the page is `ready`. */
export const useResumeAfterSignIn = (
	action: ResumeAction,
	run: (payload?: string) => void,
	ready = true,
) => {
	const { userData } = useUserDataContext();
	const signedIn = !!userData?._id;
	const runRef = useRef(run);
	runRef.current = run;

	const check = useCallback(() => {
		if (!signedIn || !ready) return;
		const marker = takeResume(action);
		if (marker) runRef.current(marker.payload);
	}, [signedIn, ready, action]);

	useEffect(() => {
		check();
		window.addEventListener(RESUME_EVENT, check);
		return () => window.removeEventListener(RESUME_EVENT, check);
	}, [check]);
};
